import React from 'react';
import {useSelector} from "react-redux";
import {
    bbDangerousStringToDate,
     bbFormattedDateString,
    bbFindEntityWithinPortfolioOrSelf,
    mapObject
} from "../../../util/bbHelpers";
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import BBDataTable from "../tables/BBDataTable";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import BBIconCheckCircleYes from "../../../assets/bbCustomIcons/BBIconCheckCircleYes";
import NewBRValidationDialog from "./NewBRValidationDialog";
import BBIconCheck from "../../../assets/bbCustomIcons/BBIconCheck";
import BBIconExclamationTriangleError from "../../../assets/bbCustomIcons/BBIconExclamationTriangleError";

const TableContainer = ({
                            portfolioView = false
                        })=> {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError,} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    // const dispatch = useDispatch();

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;

    // console.log("myEntity data", myEntity);

    //Get the domains that are already in the provided part of the state
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    // console.log("myEntity in BRValidationTable", myEntity);

    const validations = myEntity ? myEntity.validation : null;

    const totalNumItems = validations ? Object.keys(validations).length : null

    // console.log("techSubdomains is",techSubdomains, "providedSubdomains is",providedSubdomains,  "providedAndTechSubdomains is",providedAndTechSubdomains);



  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <div className={"tourStepBRReportVectorsTable"}>
        Attestations<Tooltip title={"A record of when your company has attested that we see your entire public-facing IT infrastructure."}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </div>;
    
  const userTableHeadings = [

      { field: 'addedDatetime', headerName: 'Date Added', hide: false, sortable: true, type: 'string', flex : 0.5, cellClassName: "attestationAddedDateCol",
          renderHeader: (params)=>
              <span id={"attestationAddedDateHeader"}>Date Added</span>,
          renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value
                                  ? <span>
                                      {bbFormattedDateString(params.value, "short")}
                                  </span>
                                  : "N/A"}

                          </span>
                  </Tooltip>

              ))},
      { field: 'comments', headerName: 'Comments', hide: false, sortable: true, type: 'string', flex : 1, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value}
                          </span>
                  </Tooltip>

              ))},
      { field: 'user name', headerName: 'User', hide: false, sortable: true, type: 'string', flex : 0.5, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value}
                          </span>
                  </Tooltip>

              ))},

      { field: 'validated', headerName: 'Attestation Made',
          renderHeader: (params) => <div style={{lineHeight: "normal"}}><Tooltip title={"Active"}>
              <span><BBIconCheck/></span>
          </Tooltip></div>, hide: false, sortable: true, type: 'string', width: 61, renderCell: (params) =>
              renderCellExpand(params, (<>
                      {params.value
                          ? <Tooltip title={`Attested.`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                          </Tooltip>
                          : <Tooltip title={`Attestation Removed.`}>
                                  <span>
                                    <BBIconExclamationTriangleError/>
                                  </span>
                          </Tooltip>
                      }
                  </>

              ))},
      
  ];

    //peel the state data into a form the dataTable can read
  const tableData = validations ? mapObject(validations, (key, element) => {

      return (
        {
            customerId: customer.CustomerId,
            id: key,
            idShort: key.slice(0, 6),
            user: element.user,
            addedDatetime: element.created_datetime ? bbDangerousStringToDate(element.created_datetime) : null,
            comments: element.comments,
            validated: element.validated,
            ...element

        }
    )
  }) : null;

  // console.log(tableData)

    const tableDataAsArray = () => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);
        let arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            arr.push(tableData[ob]);
        }
        // console.log("resulting array ", arr);
        return arr;
    }


    return (
        <div >
            {((validations || totalNumItems === 0)
                && myEntity
                && myEntity.settings
                && customerIdToUse
                && !loadingPortfoliosError[customerIdToUse]
                && !loadingPortfolios[customerIdToUse]
            ) ?
            <BBDataTable
                columns={userTableHeadings}
                rows={tableDataAsArray()}
                totalRows={totalNumItems}
                progressValue={validations
                    ? totalNumItems === 0
                        ? 100
                        : Object.keys(validations).length / totalNumItems * 100
                    : 0}
                // bufferValue={willBeDoneLocalPagewiseLoadingWhenTargetsIs ? willBeDoneLocalPagewiseLoadingWhenTargetsIs / totalNumTargets * 100 : 0}
                title={title}
                enableExport
                loading={false}
                // requiresModule={"monitor"}
                // requiresBRLevel = {"infoLevel3"}
                authUser = {authUser}
                entityId = {entityInView}
                customer={customer}
                topRightElement={
                    <NewBRValidationDialog
                        targetEntityId={entityInView}
                        portfolioView={portfolioView}
                    />
                    }
                defaultSortModel = {[

                    {
                        field: 'addedDatetime',
                        sort: 'desc',
                    },

                ]}
                rowsPerPageOptions = {[3, 10, 25, 50, 100]}
                defaultPageSize = {3}
            />
            :
            <BBDataTable
                columns={userTableHeadings}
                rows={[]}
                title={title}
                loading = {true}
                progressValue={0}
                bufferValue={0}
                rowsPerPageOptions = {[3, 10, 25, 50, 100]}
                defaultPageSize = {3}
            />
            }
        </div>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer